import React, { useEffect, useState } from 'react';
import GlobalStore from '../../stores/global-store';
import referralsApi from '../../apis/referrals-api';
import FilterStatus from '../../components/FilterStatus/FilterStatus';
import './Referral.css';

function Referral() {
  const {setLoading, affID} = GlobalStore.useContainer();
  const [referrals, setReferrals] = useState([]);
  const [referralsFiltered, setReferralsFiltered] = useState([]);

  useEffect( () => {
    async function getAllReferrals() {
      setLoading(true);
      const response = await referralsApi.getReferrals(affID);
      setReferrals(response.data.referrals || []);
      setReferralsFiltered(response.data.referrals || []);
      setLoading(false);
    }

    getAllReferrals();
  }, [setLoading]);

  const referralsFilterStatus = (status) => {
    let referralsFiltered = [];
    if (status === 'success') { 
      referralsFiltered = referrals.filter(item => item.status );
    } else if (status === 'fail') {
      referralsFiltered = referrals.filter(item => !item.status );
    } else {
      referralsFiltered = referrals;
    }
    setReferralsFiltered(referralsFiltered)
  }

  return (
    <div className="page-referrals container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Lượt giới thiệu</h2>
        <FilterStatus onSelectStatus={referralsFilterStatus} />
      </div>

      <hr className="mb-5" />

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Mã đơn hàng</th>
              <th>Tên khách hàng</th>
              <th>Trạng thái</th>
              <th>Giá trị đơn hàng</th>
              <th>Giá trị đơn hàng thành công</th>
              <th>Người xử lý đơn hàng</th>
              <th>Ngày mua hàng</th>
              <th>Ngày đã thanh toán</th>
            </tr>
          </thead>
          <tbody>
            { referralsFiltered.length > 0 && (
              referralsFiltered.map(item => (
                <tr key={item.lead_id}>
                  <td>{ item.lead_id }</td>
                  <td>{ item.customer_name }</td>
                  <td>{ item.status ? 'Thành công' : 'Không thành công' }</td>
                  <td>{ item.lead_amount.toLocaleString() }</td>
                  <td>{ item.deal_amount.toLocaleString() }</td>
                  <td>{ item.deal_owner }</td>
                  <td>{ item.date }</td>
                  <td>{ item.deal_closing_date }</td>
                </tr>
              ))
            )}
            { referralsFiltered.length === 0 && (
              <tr>
                <td className="text-center text-secondary" colSpan={8}>Chưa có dữ liệu</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Referral;
